<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="box-header">
          <h3 class="box-title title" style="color:#959FA9"> Detalle de pedido </h3>
          <h3 class="box-title title" style=""><span v-if="window.width > 610" class="table-btn-icon icon-space"></span> {{this.$route.params.filterOrdereDate.shippingDate | formatDate('DD/MM/YYYY')}}</h3>
        </div>
      </div>
    </div>
  <div class="box-header" style="height:80px !important">
    <router-link :to="{name: 'OrdersProgress', params: {lastSearch: true, showAdvance: this.$route.params.showAdvanceMain } }">
     <button class="btn btn-sm btn-success btnAction btn-search" style="background-color:#E2E4E6; border:none; height:48px !important; margin-bottom:30px; width:130px !important"><img class="icon-space" src="/static/img/icons/ic_back.png" style="padding-bottom:7px">Regresar</button>
    </router-link>
  </div>
  <div class="box box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"> <img src='/static/img/icons/ic_doc2.png' style="padding-bottom:7px"> Detalle: {{this.$route.params.filterOrdereDate.shippingDate | formatDate('DD/MM/YYYY')}}</h3>
    </div>
      <div class="box-body">
        <div class="filterContainer">
          <div class="row title-boreder" style="padding-bottom:25px;">
            <br>
            <div class="row">
              <div class="col-xs-1" v-if="window.width > 610">
              </div>
              <div v-if="window.width <= 610" class="col-xs-9" style="margin-left: 15px">
                <div class="progress">
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'"></div>
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'"></div>
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'"></div>
               </div>
              </div>
              <div v-if="window.width > 610" class="col-xs-9">
                <div class="progress">
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'"></div>
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'"></div>
                  <div :class="'progress-bar'" role="progressbar" :style="'background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'"></div>
               </div>
              </div>
              <div class="col-xs-2" style="padding-left:10px; position:relative; top:-10px;">
                <span style="color:#4E6982;font-size:18px;font-weight:bold;">{{this.$route.params.filterOrdereDate.orderTotal | formatAmount}}</span>
                <span style="color:#4E6982;font-size:16px;font-weight:bold;">{{this.$route.params.filterOrdereDate.minimumStockUnit}}</span>
                <span style="color:#4E6982;display:block">total</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-1" v-if="window.width > 610">
              </div>
              <div v-if="window.width <= 610" class="col-xs-3" style="border-right:3px solid #F4F6F7; margin-left: 15px">
                <div class="row" style="text-align:center">
                  <div class="col-md-2">
                    <span :style="'background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;'">&nbsp;</span>
                  </div>
                  <div class="col-md-5">
                    <span style="color:#4E6982;font-size:14px;font-weight:bold;">{{this.$route.params.filterOrdereDate.orderCompleted | formatAmount}}</span> 
                    <span style="color:#4E6982;font-size:12px;font-weight:bold;">{{this.$route.params.filterOrdereDate.minimumStockUnit}}</span>
                    <span style="color:#4E6982;display:block">Atendidos</span>
                  </div>
                  <div class="col-md-5">
                    <span style="color:#536DFE; font-size:30px;">{{this.$route.params.filterOrdereDate.totalShippedPorcentage | currency}}%</span>
                  </div>
                </div>
              </div>
              <div v-if="window.width > 610" class="col-xs-3" style="border-right:3px solid #F4F6F7">
                <div class="row" style="text-align:center">
                  <div class="col-md-2">
                    <span :style="'background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;'">&nbsp;</span>
                  </div>
                  <div class="col-md-5">
                    <span style="color:#4E6982;font-size:14px;font-weight:bold;">{{this.$route.params.filterOrdereDate.orderCompleted | formatAmount}}</span>
                    <span style="color:#4E6982;font-size:12px;font-weight:bold;">{{this.$route.params.filterOrdereDate.minimumStockUnit}}</span>
                    <span style="color:#4E6982;display:block">Atendidos</span>
                  </div>
                  <div class="col-md-5">
                    <span style="color:#536DFE; font-size:30px;">{{this.$route.params.filterOrdereDate.totalShippedPorcentage | currency}}%</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3" style="border-right:3px solid #F4F6F7">
                <div class="row" style="text-align:center">
                  <div class="col-md-2">
                  </div>
                  <div class="col-md-2">
                    <span :style="'background-color:#63CB68;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;'">&nbsp;</span>
                  </div>
                  <div class="col-md-4">
                    <span style="color:#4E6982;font-size:14px;font-weight:bold;">{{this.$route.params.filterOrdereDate.orderProgress | formatAmount}}</span>
                    <span style="color:#4E6982;font-size:12px;font-weight:bold;">{{this.$route.params.filterOrdereDate.minimumStockUnit}}</span>
                    <span style="color:#4E6982;display:block">Proceso</span>
                  </div>
                  <div class="col-md-4">
                    <span style="color:#63CB68;font-size:30px;">{{this.$route.params.filterOrdereDate.totalProgressPorcentage | currency}}%</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3" style="border-right:3px">
                <div class="row" style="text-align:center">
                  <div class="col-md-2">
                  </div>
                  <div class="col-md-2">
                    <span :style="'background-color:#4FC3F7;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;'">&nbsp;</span>
                  </div>
                  <div class="col-md-4">
                    <span style="color:#4E6982;font-size:14px;font-weight:bold;">{{this.$route.params.filterOrdereDate.orderPending | formatAmount}}</span>
                    <span style="color:#4E6982;font-size:12px;font-weight:bold;">{{this.$route.params.filterOrdereDate.minimumStockUnit}}</span>
                    <span style="color:#4E6982;display:block">Pendientes</span>
                  </div>
                  <div class="col-md-4">
                    <span style="color:#4FC3F7;font-size:30px;">{{this.$route.params.filterOrdereDate.totalPendingPorcentage | currency}}%</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-2" style="padding-left:10px; position:relative; top:-10px;">
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-md-12"  id="ordersDetail">
              <Vuetable 
                id="ordersDetail"
                ref="vuetable"
                :api-mode="false"
                :fields="tableDetail"
                :css="tableCSS.table"
                @vuetable:loading="onLoading"        
                @vuetable:loaded="onLoaded"
                noDataTemplate="No se encontraron resultados"
                :data="orderDetailTableVue"
                :data-manager="dataManager"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationData"
                :key="tableKey"
              >
                <!-- Clientes -->
                <template  slot="clientName" scope="props">
                  <div id="Cliente">
                    <span >{{props.rowData.clientName}}</span>
                  </div>
                </template>
                <!-- Atendidos -->
                <template  slot="completedOrders" scope="props">
                  <div id="Atendido">
                    <div  :style="'display: inline-flex;'">
                        <div class="progressContainer">
                            <div class="porcentajeTotal" :style="'font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;'">{{props.rowData.completedPercentage | currency}}%</div>
                          <div class="progressBar" style="position: absolute !important;margin-left: 50px;margin-top: 0px;">
                            <div class="progress table-bar percentageA" :style="'background-color:#D9DEFB'">
                              <div :class="'progress-bar progress-bar'" role="progressbar"
                                aria-valuemin="0" aria-valuemax="100" :style="'background-color:#536DFE;width:' + props.rowData.completedPercentage + '%'">
                              </div>
                              </div>
                            </div>
                          <div class="totalPorcentaje" :style="'margin:-22px  0 0 190px;color:#506A83'">
                                <span style="font-size: 16px;font-weight: bold; color:#4E6982">{{props.rowData.completedOrders | formatAmount}}</span> 
                                <span style="font-size: 14px;font-weight: bold; color:#4E6982" >{{props.rowData.minimumStockUnit}}</span>
                          </div>
                        </div>
                    </div>
                  </div>
                </template>
                <!-- Proceso -->
                <template  slot="progressOrders" scope="props">
                  <div id="Proceso" >
                    <div  class="pendiente" :style="'display: inline-flex;'">
                      <div class="progressContainer">
                        <div class="porcentajeTotal" :style="'font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;'">{{props.rowData.progressPercentage | currency}}%</div>
                        <div class="progressBar" style="position: absolute !important;margin-left: 60px;margin-top: 0px;">
                          <div class="progress table-bar" :style="'background-color:#B6F5BB'">
                            <div :class="'progress-bar progress-bar'" role="progressbar"
                              aria-valuemin="0" aria-valuemax="100" :style="'background-color:#63CB68;width:' + props.rowData.progressPercentage + '%'">
                            </div>
                          </div>
                        </div>  
                        <div class="totalPorcentaje" :style="'margin:-22px  0 0 200px;color:#4E6982'">
                          <span style="font-size: 16px;font-weight: bold; color:#4E6982">{{props.rowData.progressOrders | formatAmount}}</span> 
                          <span style="font-size: 14px;font-weight: bold; color:#4E6982" >{{props.rowData.minimumStockUnit}}</span>
                        </div>
                      </div>                     
                    </div>
                  </div>
                </template>
                <!-- Pendientes -->
                <template  slot="pendingOrders" scope="props">
                  <div id="Pendientes">
                    <div  class="pendiente" :style="'display: inline-flex;'">
                      <div class="progressContainer">
                        <div class="porcentajeTotal" :style="'font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;'">{{props.rowData.pendingPercentage | currency}}%</div>
                        <div class="progressBar" style="position: absolute !important;margin-left: 60px;margin-top: 0px;">
                          <div class="progress table-bar" :style="'background-color:#C6E9F8'">
                            <div :class="'progress-bar progress-bar'" role="progressbar"
                              aria-valuemin="0" aria-valuemax="100" :style="'background-color:#4FC3F7;width:' + props.rowData.pendingPercentage + '%'">
                            </div>
                          </div>
                        </div>  
                        <div class="totalPorcentaje" :style="'margin:-22px  0 0 200Px;color:#4E6982'">
                            <span style="font-size: 16px;font-weight: bold; color:#4E6982">{{props.rowData.pendingOrders | formatAmount}}</span> 
                            <span style="font-size: 14px;font-weight: bold; color:#4E6982" >{{props.rowData.minimumStockUnit}}</span>
                        </div>
                      </div>                     
                    </div>
                  </div>
                </template>
              </Vuetable>
            </div>
          </div>
        </div>
          <div class="row">
          <div class="col-md-6">
            &nbsp;
            <template v-if="this.paginationData && paginationData.total > 0">
              <strong style="color: #364A5D; paddin-left:15px;">
              Mostrando documento {{ this.paginationData.from }} a {{ this.paginationData.to }} de {{ this.paginationData.total }} en Total
              </strong>
            </template>
          </div>
          <div class="col-md-6">
            <vuetable-pagination ref="pagination"
              :css="tableCSS.pagination"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment/moment.js'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import constants from 'assets/js/constants.js'

export default {
  name: 'PerishableProducts',
  components: {
    Multiselect,
    Vuetable,
    'vuetable-pagination': VuetablePagination
  },
  data () {
    return {
      loader: null,
      orderDetailTableVue: null,
      orderDetail: null,
      orderDetailTable: null,
      submitted: false,
      message: '',
      order: '',
      searchParams: null,
      fetchData: null,
      selectedClient: null,
      optionsClient: null,
      chartData: null,
      tableAllData: null,
      tableKey: 1,
      tableLoad: false,
      tableClientData: null,
      window: {
        width: 0,
        height: 0
      },
      tableDetail: [
        {
          name: '__slot:clientName',
          title: 'Cliente'
        },
        {
          name: '__slot:completedOrders',
          title: 'Atendido'
        },
        {
          name: '__slot:progressOrders',
          title: 'Proceso'
        },
        {
          name: '__slot:pendingOrders',
          title: 'Pendientes'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered table-content-color'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    }
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    // Client
    this.tableCSS = constants.tableCSS
    this.optionsClient = Array.from(this.userClients)
    this.mode = constants.ordersProgressFilterModes.pending
    /* if (this.userClients.length > 1) {
      this.optionsClient.unshift(constants.defaultSelectItem)
    } */
    this.selectedClient = this.optionsClient[0]
  },
  mounted () {
    this.dataTableRefres()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    ...mapActions([
      'fetchOrdersProgressData'
    ]),
    getClass (mode) {
      let classVal = 'btn btn-sm btn-'
      classVal += this.mode === mode ? 'success' : 'default'
      return classVal
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    toggleClasses () {
      $('#pendingFilter').removeClass()
      $('#attendedFilter').removeClass()
      if (this.mode === constants.ordersProgressFilterModes.pending) {
        $('#pendingFilter').addClass('btn btn-sm btn-success')
        $('#attendedFilter').addClass('btn btn-sm btn-default')
      } else {
        $('#pendingFilter').addClass('btn btn-sm btn-default')
        $('#attendedFilter').addClass('btn btn-sm btn-success')
      }
    },
    dataTableRefres () {
      this.order = this.$route.params.filterOrdereDate
      this.orderDetail = this.order.detail
      this.orderDetailTable = []
      this.orderDetail.forEach(element => {
        this.orderDetailTable.push({
          clientName: element.clientName,
          completedPercentage: element.completedPercentage,
          pendingPercentage: element.pendingPercentage,
          progressPercentage: element.progressPercentage,
          completedOrders: element.completedOrders,
          progressOrders: element.progressOrders,
          pendingOrders: element.pendingOrders,
          minimumStockUnit: this.order.minimumStockUnit
        })
      })
      this.orderDetailTableVue = {
        data: this.orderDetailTable
      }
      this.tableKey++
      this.loader.hide()
    },
    formatProgress (documentProgress) {
      let classVal = ''

      if (documentProgress > 0) {
        classVal = 'success'
      }

      return classVal
    },
    onModeSelect (mode) {
      document.activeElement.blur()
      this.changeFilter(mode)
    },
    changeFilter (mode) {
      this.mode = mode
      this.toggleClasses()
      this.loadChartData()
    },
    search () {
      document.activeElement.blur()
      this.submitted = true

      if (this.validate()) {
        this.chartData = null
        this.headerText = ''
        this.tableAllData = null
        this.tableClientData = null

        this.searchParams = {
          AccountCodes: [this.selectedClient.code],
          StartDate: $(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate.format('YYYYMMDD'),
          EndDate: $(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate.format('YYYYMMDD')
        }
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        this.fetchOrdersProgressData(this.searchParams).then((data) => {
          if (data != null) {
            this.fetchData = data
            this.loadChartData()

            if (this.searchParams.AccountCodes.length > 1) {
              this.loadDetail()
            } else {
              this.loadClientDetail()
            }

            this.submitted = false

            this.loader.hide()
          }
        })
      }
    },
    goSearch () {
      window.location = '/AvancePedidos'
    },
    validate () {
      let startDate = moment($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate)
      let endDate = moment($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate)
      let days = moment.duration(endDate.diff(startDate)).asDays()

      if (days < 0 || days > 7) {
        this.message = 'El rango de Fechas permitido es de 7 días.'
        return false
      } else {
        this.message = ''
        return true
      }
    },
  /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.paginationData = paginationData
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
      this.searchDocumentPage(page)
    },
    loadChartData () {
      let formattedData = this.formatChartData()

      if (this.mode === constants.ordersProgressFilterModes.pending) {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [
            {
              label: 'Pendientes',
              backgroundColor: formattedData.Color,
              data: formattedData.PendingPorcentage
            },
            {
              label: 'Total',
              backgroundColor: formattedData.TotalColor,
              data: formattedData.TotalPendingPorcentage
            }
          ]
        }
      } else {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [
            {
              label: 'Atendidos',
              backgroundColor: formattedData.Color,
              data: formattedData.ShippedPorcentage
            },
            {
              label: 'Total',
              backgroundColor: formattedData.TotalColor,
              data: formattedData.TotalShippedPorcentage
            }
          ]
        }
      }
    },
    formatChartLabels () {
      let chartLabels = []
      // moment.locale('es')
      let startDate = moment($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate)
      let endDate = moment($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate)

      let days = moment.duration(endDate.diff(startDate)).asDays()

      while (days >= 0) {
        // labels.push(this.$options.filters.formatFirstLetter(startDate.format('dddd')) + ' ' + startDate.format('DD/MM/YYYY'))
        chartLabels.push(startDate.format('DD/MM/YYYY'))
        startDate = startDate.add(1, 'days')
        days = moment.duration(endDate.diff(startDate)).asDays()
      }

      return chartLabels
    },
    formatChartData () {
      let data = this.fetchData
      // Final Chart Data Object
      let chartData = {
        Total: [],
        Shipped: [],
        Color: [],
        TotalColor: [],
        Pending: [],
        TotalPendingPorcentage: [],
        TotalShippedPorcentage: [],
        PendingPorcentage: [],
        ShippedPorcentage: []
      }

      // Data sorting by Date
      if (data) {
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })
      }

      // Chart Labels
      let labels = this.formatChartLabels()

      let formatObj = {}

      labels.forEach(element => {
        formatObj[element] = {
          Total: 0,
          Pending: 0
        }
      })

      // Format Data against Chart Labels
      data.forEach(element => {
        let currentDate = moment(element.date).format('DD/MM/YYYY')
        if (formatObj[currentDate] !== undefined) {
          formatObj[currentDate].Total += element.completedOrders
          formatObj[currentDate].Pending += element.pendingOrders
          formatObj[currentDate].Color = element.chartColor && element.chartColor != null ? element.chartColor : constants.colorPalette.baseBlue
          formatObj[currentDate].TotalColor = element.chartColor && element.chartColor != null ? element.chartColor + '80' : constants.colorPalette.baseBlue
        }
      })

      // Formatted Data against Final Chart Data Object
      labels.forEach(element => {
        let formattedItem = formatObj[element]
        chartData.Total.push(formattedItem.Total)
        chartData.Shipped.push(formattedItem.Total - formattedItem.Pending)
        chartData.Pending.push(formattedItem.Pending)
        chartData.Color.push(formattedItem.Color)
        chartData.TotalColor.push(formattedItem.TotalColor)
        chartData.TotalPendingPorcentage.push(Math.round((100 - ((formattedItem.Pending * 100) / formattedItem.Total)), 2))
        chartData.TotalShippedPorcentage.push(Math.round((100 - (((formattedItem.Total - formattedItem.Pending) * 100) / formattedItem.Total)), 2))
        chartData.PendingPorcentage.push(Math.round(((formattedItem.Pending * 100) / formattedItem.Total), 2))
        chartData.ShippedPorcentage.push(Math.round((((formattedItem.Total - formattedItem.Pending) * 100) / formattedItem.Total), 2))
      })

      return chartData
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
      if (this.$route.params.tracking && !this.loadeadBack) {
        this.loadeadBack = true
        this.$refs.vuetable.changePage(this.documentSearch.page)
      }
    },
    formatClient (value) {
      let formattedVal = this.userClients.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    formatDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    /* DropDownList Events */
    onClientSelect (client) {
      this.selectedClient = client
    },
    dataManager (sortOrder, pagination) {
      let data = []

      if (this.orderDetailTableVue) {
        data = this.orderDetailTableVue.data

        pagination = this.$refs.vuetable.makePagination(data.length)

        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }
      return {
        pagination: pagination,
        data: data
      }
    },
    /* Chart Events */
    loadDetail () {
      this.headerText = moment(this.shipedDate).format('DD/MM/YYYY') + ' - ' + moment(this.shipedDate).format('DD/MM/YYYY')

      let formatObj = {}

      this.fetchData.forEach(element => {
        if (selectedDate === undefined || selectedDate === moment(element.date).format('DD/MM/YYYY')) {
          if (formatObj[element.accountCode]) {
            formatObj[element.accountCode].Total += element.totalOrders
            formatObj[element.accountCode].Pending += element.pendingOrders
          } else {
            formatObj[element.accountCode] = {
              Total: element.totalOrders,
              Completed: element.completedOrders,
              Pending: element.pendingOrders,
              Progress: element.progressOrders
            }
          }
        }
      })
      this.tableAllData = []
      let keys = Object.keys(formatObj)

      keys.forEach(element => {
        let formattedItem = formatObj[element]
        this.tableAllData.push({
          accountCode: element,
          orderTotal: formattedItem.Total,
          completedOrders: formattedItem.Completed,
          orderProgress: formattedItem.Progress,
          orderPending: formattedItem.Pending
        })
      })
    },
    loadClientDetail () {
      let filterClientCode = this.searchParams.AccountCodes[0]
      this.tableClientData = []
      this.fetchData.forEach(element => {
        if (element.accountCode === filterClientCode) {
          this.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            completedOrders: element.completedOrders,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : (100 * element.pendingOrders) / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : (100 * element.progressOrders) / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : (100 * element.completedOrders) / element.totalOrders
          })
        }
      })
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

.vuetable-th-slot-clientName { 
  width: 25%; 
}

.vuetable-th-slot-completedOrders{ 
  width: 25%; 
}

.vuetable-th-slot-progressOrders{ 
  width: 25%; 
}

.vuetable-th-slot-pendingOrders{ 
  width: 25%; 
}

#ordersDetail .progressBar,
.progressInfo {
  position: absolute !important;

}

#ordersDetail .vuetable-empty-result{
  text-align: center !important;
} 

#ordersDetail th#_clientName {
width: 30% !important; 
}

@media screen and (max-width: 1200px) {

  #ordersDetail .progressContainer {
    margin-top: 15px !important;
    width: 50%;
    left: -126px;
  }

/*   #ordersDetail .progressBar,
.progressInfo {
  position: relative !important;

} */


 
  .totalPorcentaje{
   margin:-25px  10 0 110px !important;
  }

   #ordersDetail table {
      border: 0;
    }

   #ordersDetail table thead {
      display: none;
    }

   /*  #ordersDetail tr {
    height: 325px !important
    } */

/*     #ordersDetail td {
    padding: 20px !important;
    } */

   #ordersDetail table tr {
	    margin-top: 10px;
      margin-bottom: 20px;
      display: block;
      border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #ordersDetail table td {
      display: block;
      border: none !important;
      font-size: 13px;
      text-align: right !important;
    }

   #ordersDetail table td:last-child {
      border-bottom: 0;
    }

    #ordersDetail table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#ordersDetail	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }

</style>



// WEBPACK FOOTER //
// OrdersProgressDetail.vue?03d6d698